import {
  BaseQueryApi,
  BaseQueryFn,
  DefinitionType,
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
//   import ErrorHandler from "../../components/ui/errorHandler";

// const baseUrl = "http://localhost:7800/api";
const baseUrl =
  import.meta.env.VITE_NODE_ENV === "development"
    ? import.meta.env.VITE_API_CHAT_URL_DEV
    : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CHAT_URL_STAGE
      : import.meta.env.VITE_API_CHAT_URL_PROD;

// console.log(baseUrl);
// console.log("Base URL:", baseUrl);
const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState)?.auth?.token;
    if (token) {
      headers.set("authorization", token);
    }
    return headers;
  },
});

const baseQueryWithRefreshToken: BaseQueryFn<
  FetchArgs,
  BaseQueryApi,
  DefinitionType
> = async (args, api, extraOptions): Promise<any> => {
  let result = await baseQuery(args, api, extraOptions);

  // RE
  return result;
};

export const chatBaseApi = createApi({
  reducerPath: "chatBaseApi",
  baseQuery: baseQueryWithRefreshToken,
  tagTypes: ["semester", "course", "Template", "rooms", "room-data"],
  endpoints: () => ({}),
});
